import { plugins } from './GsapPlugins';

import {Power3, TweenLite} from 'gsap';

const ScrollPage = (id) => {
  const header = document.querySelector('header');
  const headerHeight = header.offsetHeight;
  const target = `[id='${id}']`;

  TweenLite.to(window, 0.8, {
    scrollTo: {
      y: target,
      offsetY: headerHeight * 2,
      autoKill: false
    },
    ease: Power3.easeInOut
  });
};

export default ScrollPage;
